var _path, _g, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlaza(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "496pt",
    viewBox: "0 0 496 496",
    width: "496pt",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m268.945312 48-24-48h-57.890624l-24 48h12.945312v16h16v-16h48v16h16v-16zm-72-32h38.109376l8 16h-54.109376zm0 0"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#f0bc5e"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m272 104h-112v-40h112zm0 0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m304 376h16v56h-16zm0 0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m272 352h16v48h-16zm0 0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m240 352h16v48h-16zm0 0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m208 352h16v48h-16zm0 0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m176 352h16v48h-16zm0 0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m144 352h16v48h-16zm0 0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m112 352h16v80h-16zm0 0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m80 368h16v88h-16zm0 0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m48 216h336v32h-336zm0 0"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m390.351562 186.816406-115.582031-90.816406h-117.539062l-115.582031 90.816406-14.59375 29.183594h377.890624zm-221.847656-34.816406h16.359375l-4.917969 16h-22.511718zm-30.542968 16h-46.464844l20.503906-16.113281v.113281h37.039062zm97.847656-56 16.617187 24h-10.210937l-7.382813-24zm-10.328125 24h-18.960938l7.382813-24h4.1875zm4.917969 16 4.921874 16h-38.648437l4.921875-16zm-33.230469-40-7.382813 24h-10.210937l16.617187-24zm-22.152344 72-4.917969 16h-34.824218l11.078124-16zm16.738281 0h48.492188l4.921875 16h-58.34375zm65.230469 0h28.671875l11.078125 16h-34.824219zm-4.921875-16-4.917969-16h16.359375l11.082032 16zm30.898438-16h37.039062v-.113281l20.503906 16.113281h-46.464844zm16.816406-16h-27.898438l-16.613281-24h13.964844zm-137.007813-24h13.964844l-16.613281 24h-27.898438zm-108.417969 85.183594 16.777344-13.183594h55.75l-11.078125 16h-62.855469zm261.839844 2.816406-11.078125-16h55.75l16.777344 13.183594 1.414063 2.816406zm0 0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m448 448h-16v-40c0-17.648438-14.351562-32-32-32h-32v-128h-16v128h-16v-128h-16v125.761719l-37.191406-29.761719h-10.808594v-96h-16v96h-16v-96h-16v96h-16v-96h-16v96h-16v-96h-16v96h-48v-96h-16v105.601562l-16 11.429688v-117.03125h-16v128.457031l-16 11.429688v92.113281h-16v16h432v-16h-16zm-80-24h16v56h-16zm64 40v16h-32v-16zm-16-56v40h-16v-40h-37.191406l-20-16h57.191406c8.824219 0 16 7.175781 16 16zm-301.441406-48h162.632812l74.808594 59.839844v28.160156h-16v-24h-48v-32h-144v32h-32v24h-48v-51.878906zm-50.558594 104h64v-24h32v-32h112v32h48v24h32v16h-288zm0 0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m480 480h16v16h-16zm0 0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m0 480h16v16h-16zm0 0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaza);
export default __webpack_public_path__ + "static/media/plaza.8c4bb6ad87e977ec2921583e1153d5e8.svg";
export { ForwardRef as ReactComponent };